window.timePickerInit = function timePickerInit() {
  const metaTimePickersArr = document.querySelectorAll('.meta-time-picker');
  metaTimePickersArr.forEach((metaTimePicker, i) => {
    if (!metaTimePicker.classList.contains('is-time-picker-init')) {
      const zIndexValue = metaTimePicker.length - i;
      metaTimePicker.style.zIndex = zIndexValue + 10;

      metaTimePicker.classList.add('is-time-picker-init');
      const input = metaTimePicker.querySelector('input');
      const pickerElement = metaTimePicker.querySelector('.js-inline-picker');

      const max = +pickerElement.dataset.max;
      const min = +pickerElement.dataset.min;
      const step = +pickerElement.dataset.step;

      const metaTimePickerList = metaTimePicker.querySelector(
        '.meta-time-picker__list'
      );

      const timePicker = new Picker(pickerElement, {
        controls: true,
        inline: true,
        rows: 1,
        format: 'HH:mm',
        text: {
          title: 'Оберіть час',
        },
      });

      const decreaseButton = metaTimePicker.querySelector(
        '.picker-minutes .picker-cell__control--prev'
      );

      // Function to round minutes up to the nearest interval
      function roundUpToNearestInterval(date, interval) {
        let minutes = date.getMinutes();
        let roundedMinutes = Math.ceil(minutes / interval) * interval;
        if (roundedMinutes >= 60) {
          roundedMinutes = 0;
          date.setHours(date.getHours() + 1);
        }
        date.setMinutes(roundedMinutes);
        date.setSeconds(0);
        return date;
      }

      // Function to round minutes down to the nearest interval
      function roundDownToNearestInterval(date, interval) {
        let minutes = date.getMinutes();
        let roundedMinutes = Math.floor(minutes / interval) * interval;
        if (roundedMinutes < 0) {
          roundedMinutes = 45;
          date.setHours(date.getHours() - 1);
        }
        date.setMinutes(roundedMinutes);
        date.setSeconds(0);
        return date;
      }

      // Function to update the time picker and round minutes
      function updateTimePicker() {
        let date = timePicker.getDate(true);
        if (date) {
          // If `date` is a string, convert it to a Date object
          if (typeof date === 'string') {
            const [hours, minutes] = date.split(':').map(Number);
            date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            date.setSeconds(0);
          }

          const currentHours = date.getHours();
          const currentMinutes = date.getMinutes();

          // Round minutes up
          date = roundUpToNearestInterval(date, step);

          // Set hours and minutes in the time picker
          date.setHours(currentHours); // Restore original hours
          date.setMinutes(date.getMinutes());

          timePicker.setDate(date);

          input.value = date.toISOString().substr(11, 5);

          checkInputValue(input);
        }
      }

      // Function to decrease time by 15 minutes
      function decreaseTime() {
        let date = timePicker.getDate(true);
        if (date) {
          if (typeof date === 'string') {
            const [hours, minutes] = date.split(':').map(Number);
            date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            date.setSeconds(0);
          }

          const currentHours = date.getHours();
          const currentMinutes = date.getMinutes();

          // Decrease minutes and round down
          date.setMinutes(currentMinutes - step);
          date = roundDownToNearestInterval(date, step);

          // Restore original hours
          date.setHours(currentHours);

          timePicker.setDate(date);
          input.value = date.toISOString().substr(11, 5);

          checkInputValue(input);
        }
      }

      // Event handler for clicking the decrease button
      if (decreaseButton) {
        decreaseButton.addEventListener('click', decreaseTime);
      }

      function handlePickerChange(mutationsList) {
        for (const mutation of mutationsList) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'data-value'
          ) {
            updateTimePicker();
            input.value = timePicker.getDate(true);
            checkInputValue(input);
          }
        }
      }

      const observer = new MutationObserver(handlePickerChange);

      const observerConfig = {
        attributes: true,
        subtree: true,
        attributeFilter: ['data-value'],
      };

      observer.observe(pickerElement, observerConfig);

      function checkInputValue(input) {
        const timeValue = input.value;
        const [hours, minutes] = timeValue.split(':').map(Number);

        // Check if the time is within the range 10:00 - 11:00
        if (
          (hours === min && minutes >= 0) ||
          (hours === min && minutes === 59)
        ) {
          metaTimePicker.classList.add('time-too-early');
          metaTimePicker.classList.remove('time-too-late');
        }
        // Check if the time is within the range 18:00 - 19:00
        else if (
          (hours === max && minutes >= 0) ||
          (hours === max && minutes === 59)
        ) {
          metaTimePicker.classList.add('time-too-late');
          metaTimePicker.classList.remove('time-too-early');

          setTimeout(function () {
            metaTimePicker.querySelector(
              '.picker-item.picker-picked[data-name="minute"]'
            ).textContent = '00';
            input.value = `${max}:00`;
          }, 50);
        }
        // Check if the time is within the valid range
        else {
          metaTimePicker.classList.remove('time-too-early', 'time-too-late');
        }
      }

      metaTimePicker.addEventListener('click', (e) => {
        if (!metaTimePicker.classList.contains('active')) {
          metaTimePicker.classList.add('active');
        } else {
          if (!metaTimePickerList.contains(e.target)) {
            metaTimePicker.classList.remove('active');
          }
        }
      });

      document.addEventListener('click', (event) => {
        if (
          !metaTimePickerList.contains(event.target) &&
          !metaTimePicker.contains(event.target)
        ) {
          metaTimePicker.classList.remove('active');
        }
      });
    }
  });
};

if (document.querySelector('.meta-time-picker')) {
  timePickerInit();
}
